import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import { RelativeWrapper, ScrollableDropdownRoundedCornersWrapper, Mx2, Mt2, Pb2 } from 'wrappers';
import Controller from './controller';
import internalState from './internalState';
import { prioritySettings } from 'utils';
import { IconLabel } from 'molecules';

const containerRef = React.createRef();

export const definition = {
  name: 'PriorityInput',
  controller: Controller,
  initialProps: ({ selectedPriority, priorities, displayLeft }) => ({ selectedPriority, priorities, displayLeft }),
  props: internalState,
  elements: [
    {
      component: IconLabel,
      name: 'Selector',
      bindings: ({ isOpen, priorities, selectedPriority }) => {
        let priority = priorities.find(priority => priority.id === selectedPriority)
        return { isOpen, containerRef, text: priority?.name?.toUpperCase(), icon: prioritySettings.icon(priority) }
      },
      displayState: ({ selectedPriority, priorities }) => {
        let priority = priorities.find(priority => priority.id === selectedPriority)
        return {
          background: prioritySettings[priority?.color]?.background,
          color: prioritySettings[priority?.color]?.textColor,
          clickable: true
        }
      },
    },
    {
      wrapper: ScrollableDropdownRoundedCornersWrapper,
      name: 'Body',
      ref: containerRef,
      displayState: ({ displayLeft }) => ({ displayLeft, minWidth: '150px' }),
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          wrapper: Pb2,
          name: 'Wrapper',
          elements: [
            {
              component: wrap(wrap(IconLabel, Mx2), Mt2),
              name: 'Option',
              isListOf: 'priorities',
              bindings: ({ priority }) => ({ priority, text: priority?.name?.toUpperCase() ?? '', icon: prioritySettings.icon(priority) }),
              displayState: ({ priority }) => ({
                background: prioritySettings[priority?.color]?.background,
                color: prioritySettings[priority?.color]?.textColor,
                clickable: true
              })
            }
          ]
        }
      ]
    }
  ]
};

const PriorityInput = ContainerComponent(definition);

export default wrap(PriorityInput, RelativeWrapper);